import { render, staticRenderFns } from "./SignatureSettingPanel.vue?vue&type=template&id=5bc01c1f&scoped=true&"
import script from "./SignatureSettingPanel.vue?vue&type=script&lang=js&"
export * from "./SignatureSettingPanel.vue?vue&type=script&lang=js&"
import style0 from "./SignatureSettingPanel.vue?vue&type=style&index=0&id=5bc01c1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc01c1f",
  null
  
)

export default component.exports